import classes from './typography.module.scss';
import { clsx } from 'clsx';

const TYPOGRAPHY_MAP = {
  'display-2xl': classes.display2xl,
  'display-xl': classes.displayXl,
  'display-lg': classes.displayLg,
  'display-md': classes.displayMd,
  'display-sm': classes.displaySm,
  'display-xs': classes.displayXs,
  'text-xl': classes.textXl,
  'text-lg': classes.textLg,
  'text-md': classes.textMd,
  'text-sm': classes.textSm,
  'text-xs': classes.textXs,
};

export const Typography = ({
  variant,
  children,
  className,
  color,
  weight,
}: {
  variant: keyof typeof TYPOGRAPHY_MAP;
  children: React.ReactNode;
  className?: string;
  color?: string;
  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
}) => {
  return (
    <div
      className={clsx(
        classes.base,
        classes[variant],
        weight && classes[weight],
        className
      )}
    >
      {children}
    </div>
  );
};
